import { useAppSelector } from '@/redux/hooks';
import {
    getAllCatalogIds,
    getCatalogIdsByIdsLive,
    getCatalogIdsByIdsNotDone,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getUpcomingCatalogIds } from '@/redux/modules/home/home.selectors';

const useGetUpcomingOrLiveCatalogs = (): [boolean, number[]] => {
    const allCatalogIds = useAppSelector(getAllCatalogIds);
    const allUpcomingCatalogIds = useAppSelector((state) => getCatalogIdsByIdsNotDone(state, allCatalogIds));
    const upcomingCatalogIds = useAppSelector(getUpcomingCatalogIds);
    const liveCatalogIds = useAppSelector((state) => getCatalogIdsByIdsLive(state, upcomingCatalogIds));
    const catalogIds = liveCatalogIds.length ? liveCatalogIds : allUpcomingCatalogIds || [];
    return [Boolean(liveCatalogIds.length), catalogIds];
};

export default useGetUpcomingOrLiveCatalogs;
